import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number | string
}

const EmptyFolderIllustration: FC<Props> = ({ size = 60 }) => {
  const [primary100, primary500, primary700, gray50, gray900] = useToken('colors', [
    'primary.100',
    'primary.500',
    'primary.500',
    'gray.50',
    'gray.900',
  ])

  const bgColor = useColorModeValue(gray50, gray900)
  const strokeColor = useColorModeValue(primary500, primary700)
  const strokenWidth = '6px'
  const fillFolder = useColorModeValue(primary100, primary100)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 569.9 559.5">
        <g id="BG">
          <path
            fill={bgColor}
            d="M553.85,419.76,521.34,397l-4.78-3.34A232.19,232.19,0,0,0,534.45,304c0-128.68-104.31-233-233-233a232,232,0,0,0-107.1,26c-12.44-8.81-24.69-18.21-37.59-26.3-.2-.12-.38-.27-.57-.4-6.64-4.65-16.67-1.2-20.52,5.38-4.38,7.49-1.27,15.87,5.38,20.53l25.44,17.81a235.19,235.19,0,0,0-22.21,18l-27.61-19.34c-13.24-9.27-26.21-19.35-39.91-27.94-.2-.12-.38-.27-.57-.4-6.64-4.65-16.67-1.2-20.52,5.38-4.38,7.49-1.27,15.87,5.38,20.53l32.68,22.88,29.59,20.72a234.18,234.18,0,0,0-16.44,22C96.72,168.49,86.59,160.92,76,154.31c-.19-.12-.37-.26-.55-.39-6.64-4.65-16.67-1.2-20.52,5.39-4.38,7.48-1.27,15.86,5.38,20.52l31.45,22L92,202a231.9,231.9,0,0,0-23.5,102c0,128.68,104.32,233,233,233a232.24,232.24,0,0,0,166.76-70.3l18.18,12.74c13.19,9.23,26.11,19.28,39.76,27.83.19.12.37.27.56.4,6.64,4.65,16.67,1.2,20.53-5.38,4.37-7.49,1.27-15.87-5.39-20.53L509.34,459,487.78,443.9a234.37,234.37,0,0,0,15.33-23.12c11.57,8.27,23,17,35,24.49.19.12.37.27.56.4,6.64,4.65,16.67,1.2,20.53-5.38C563.61,432.8,560.51,424.42,553.85,419.76Z"
          />
          <path
            fill={bgColor}
            d="M39.17,130.62l-16.71-11.7c-6.45-4.51-17-1.38-20.52,5.39C-2.12,132,.44,140,7.32,144.83L24,156.53c6.45,4.51,16.95,1.38,20.52-5.38C48.61,143.47,46.05,135.44,39.17,130.62Z"
          />
        </g>
        <g id="Stars">
          <g id="Star">
            <path fill={strokeColor} d="M529.45,204.5h16a1.5,1.5,0,0,0,0-3h-16a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M536,195v16a1.5,1.5,0,0,0,3,0V195a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-2" data-name="Star">
            <path fill={strokeColor} d="M271.45,124.5h12a1.5,1.5,0,0,0,0-3h-12a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M276,117v12a1.5,1.5,0,0,0,3,0V117a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-3" data-name="Star">
            <path fill={strokeColor} d="M412.45,464.5h10a1.5,1.5,0,1,0,0-3h-10a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M416,458v10a1.5,1.5,0,0,0,3,0V458a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-4" data-name="Star">
            <path fill={strokeColor} d="M312.45,554.5h10a1.5,1.5,0,1,0,0-3h-10a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M316,548v10a1.5,1.5,0,0,0,3,0V548a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-5" data-name="Star">
            <path fill={strokeColor} d="M262.45,484.5h10a1.5,1.5,0,1,0,0-3h-10a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M266,478v10a1.5,1.5,0,0,0,3,0V478a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-6" data-name="Star">
            <path fill={strokeColor} d="M132.45,414.5h10a1.5,1.5,0,1,0,0-3h-10a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M136,408v10a1.5,1.5,0,0,0,3,0V408a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-7" data-name="Star">
            <path fill={strokeColor} d="M546.45,334.5h22a1.5,1.5,0,0,0,0-3h-22a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M556,322v22a1.5,1.5,0,0,0,3,0V322a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-8" data-name="Star">
            <path fill={strokeColor} d="M38.45,354.5h18a1.5,1.5,0,0,0,0-3h-18a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M46,344v18a1.5,1.5,0,0,0,3,0V344a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-9" data-name="Star">
            <path fill={strokeColor} d="M427.45,84.5h20a1.5,1.5,0,0,0,0-3h-20a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M436,73V93a1.5,1.5,0,0,0,3,0V73a1.5,1.5,0,0,0-3,0Z" />
          </g>
          <g id="Star-10" data-name="Star">
            <path fill={strokeColor} d="M145.45,164.5h24a1.5,1.5,0,0,0,0-3h-24a1.5,1.5,0,0,0,0,3Z" />
            <path fill={strokeColor} d="M156,151v24a1.5,1.5,0,0,0,3,0V151a1.5,1.5,0,0,0-3,0Z" />
          </g>
        </g>
        <g id="Folder">
          <path
            fill={fillFolder}
            strokeWidth="8px"
            stroke={strokeColor}
            strokeMiterlimit="10"
            d="M409.55,407.49s18.11,2,20.12-20.12c1.29-14.17,8.16-134,6-159-.76-8.9-20.71-7.9-28.76-7.9s-121,1-121,1-2-17-5.19-17.25c-8.95-.7-76.47,0-78.48,2s-6,12.08-6,44.27v155Z"
          />
          <path
            fill={fillFolder}
            strokeWidth="8px"
            stroke={strokeColor}
            strokeMiterlimit="10"
            d="M408.52,408.5l-211.3-2c-13.28,0-16.09-6.84-16.09-20.13l-8-114.7c0-13.28.8-20.12,14.08-20.12l199.22-4c13.28,0,30.19,6.85,30.19,20.13l10.06,114.7C426.63,395.62,421.8,408.5,408.52,408.5Z"
          />
          <g>
            <circle fill={strokeColor} cx="527.29" cy="25.15" r="10.06" />
            <circle fill={strokeColor} cx="527.29" cy="37.23" r="10.06" />
            <circle fill={strokeColor} cx="515.21" cy="29.18" r="10.06" />
            <circle fill={strokeColor} cx="541.37" cy="27.17" r="13.08" />
            <circle fill={strokeColor} cx="523.26" cy="13.08" r="13.08" />
            <circle fill="#fff" cx="543.38" cy="27.17" r="4.02" />
            <circle fill="#fff" cx="523.26" cy="13.08" r="4.02" />
            <path
              fill={strokeColor}
              d="M538.61,3c0,2.49-1.07,5-2,7.31q-.87,2.19-1.93,4.31l1.37.58c0-.1-.13.22,0,0l.23-.4a3.13,3.13,0,0,1,.36-.48,10.09,10.09,0,0,1,.77-.83,28.86,28.86,0,0,1,7.36-4.84c.86-.44.1-1.73-.76-1.3a29.72,29.72,0,0,0-7.73,5.15,6.47,6.47,0,0,0-1.67,2.27.75.75,0,0,0,1.37.58c.77-1.53,1.45-3.09,2.09-4.67,1-2.42,2-5.07,2-7.71a.75.75,0,0,0-1.5,0Z"
            />
          </g>
          <g>
            <path
              fill="none"
              strokeLinecap="round"
              strokeWidth={strokenWidth}
              stroke={strokeColor}
              strokeMiterlimit="10"
              d="M326.05,202.24s1.21-2.85,3.41-7.24"
            />
            <path
              fill="none"
              strokeLinecap="round"
              strokeWidth={strokenWidth}
              stroke={strokeColor}
              strokeMiterlimit="10"
              strokeDasharray="16.37 16.37"
              d="M337.46,180.73c9.16-14.69,23.08-31.69,38.9-32.82,28.18-2,64.4,20.12,86.53,14.08s30.19-22.13,30.19-42.26-10.06-30.18-4-42.26a110.1,110.1,0,0,1,6.52-11.11"
            />
            <path
              fill="none"
              strokeLinecap="round"
              strokeWidth={strokenWidth}
              stroke={strokeColor}
              strokeMiterlimit="10"
              d="M500.26,59.65c2.82-3.84,4.89-6.32,4.89-6.32"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(EmptyFolderIllustration)
